<template>
    <div>
        <div class="d-flex align-items-center" style="margin-top: 12px;">
            <h5 class="mb-0">Словарь</h5>
            <div class="d-flex ml-auto">
                <div>
                    <b-icon
                        v-if="$mq != 'sm'"
                        icon="search"
                        scale="1.3"
                        class="table-input-search_icon"
                        variant="secondary"
                    />
                    <input class="form-control table-input-search" type="search" placeholder="Поиск" v-model="filter">
                </div>
                <b-button
                    @click="getDictionary()"
                    size="sm"
                    variant="outline-secondary"
                    class="ml-2"
                    
                    :disabled="loading"
                >
                    <b-icon icon="arrow-repeat" scale="1.5" aria-label="Reload" :animation="loading ? 'spin' : ''"></b-icon>
                </b-button>                                
                <button
                    :disabled="loading"
                    @click="isOpen = true"
                    class="btn btn-outline-primary ml-2"
                >
                    Создать запись
                </button>                
            </div>
        </div>

        <h5 class="mt-5 mb-4">Список значений</h5>
        <BdrNestedRecords 
            :records="filtredItems" 
            :level="1"
            :unitOptions="unitOptions"
            :parentOptions="parentOptions"
        ></BdrNestedRecords>

        <BdrDictionarySidebar
            :isOpen.sync='isOpen'
            @updateItem="getDictionary"
        ></BdrDictionarySidebar>        
    </div>
</template>

<script>
import { API_BDR_DICTIONARY } from '@/constants';
import BdrNestedRecords from '@/components/bdrPage/BdrNestedRecords';
import BdrDictionarySidebar from '@/components/bdrPage/BdrDictionarySidebar';

const initialDictionaryElement = () => (
    {
        name: '',
        unit: 'B2C',
        external_number: '',
        parent_id: 0
    }
);

export default {
    name: "BDRDictionary",
    components: {
        BdrNestedRecords,
        BdrDictionarySidebar
    },    
    data() {
        return {
            loading: false,
            dictionary: [],
            filter: '',
            parentOptions: [
                {
                    text: '0: КОРНЕВАЯ ГРУППА',
                    value: 0
                }
            ],
            unitOptions: [
                {
                    text: 'Танаис B2C',
                    value: 'B2C'
                },
                {
                    text: 'Танаис B2B',
                    value: 'B2B'
                },
                {
                    text: 'БСЗ',
                    value: 'БСЗ'
                },
            ],
            isOpen: false
        };
    },

    computed: {
        filtredItems() {
            if (this.filter) {
                const search = this.filter.toLowerCase();
                return this.dictionary.filter(item => this.matchesSearch(item, search));
            } else {
                return this.dictionary;
            }         
        }
    },
    mounted() {
        this.getDictionary();
    },
    methods: {
        getDictionary() {
            this.loading = true;
            axios.get(`${API_BDR_DICTIONARY}?easylist=true`).then(({ data }) => {
                this.dictionary = data;
                this.formNestedParentOptions(this.dictionary, 0, '')
                this.loading = false;
            });
        },

        formNestedParentOptions(dictionary, parent_id, addsymb = '') {
            dictionary.forEach((reference, index) => {
                let addSmth = '';
                if (reference.external_number) {
                    addSmth = `, ${reference.external_number}`
                }
                this.parentOptions.push({
                    value: reference.id,
                    text: `${addsymb}${reference.id}: ${reference.name} (${reference.unit}${addSmth})`
                });

                if (reference.children && reference.children.length > 0) {
                    this.formNestedParentOptions(reference.children, reference.id, addsymb + '-');
                }
            })
        },

        matchesSearch(item, search) {
            if (item.name.toLowerCase().includes(search)) {
                return true;
            }
            if (item.external_number && item.external_number.toLowerCase().includes(search)) {
                return true;
            }
            if (item.children) {
                for (let child of item.children) {
                    if (this.matchesSearch(child, search)) {
                        return true;
                    }
                }
            }
            return false;
        }        
    },
};
</script>